export const basePrompt = `The question is below along with the maximum marks in square brackets. The mark scheme is also given under each question, indicating how marks are awarded.   
  
# Questions with Mark Scheme
`;
